<main>
  <div>❌</div>
  <div class="fill">{{data.errorMessage}}</div>
  <div>
    <button mat-button
            color="accent"
            (click)="reload()">{{data.action}}</button>
  </div>
</main>
